var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.path,{tag:"component",attrs:{"edit":_vm.edit,"type":_vm.type,"id":_vm.id,"card_item":_vm.card_item,"options":_vm.options,"advanced_menu":_vm.advanced_menu}})}
var staticRenderFns = []

export { render, staticRenderFns }